import { Accordion, AccordionDetails, AccordionSummary } from "@material-ui/core";

import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { Dispatch, ReactNode, SetStateAction } from "react";
import IconButton from "../IconButton";

import "./index.scss";
interface SubMenuAccordionProps {
  children: ReactNode;
  text: string;
  icon: any;
  status: boolean;
  className?: string;
  accordionSide: string;
  setAccordionSide: Dispatch<SetStateAction<string>>;
}

export default function SubMenuAccordion({ children, text, icon, status, className, accordionSide, setAccordionSide }: SubMenuAccordionProps) {
  return (
    <div className="subMenuAccordionContainer">
      {!status ? (
        <Accordion expanded={text === accordionSide ? true : false}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            onClick={() => setAccordionSide(text === accordionSide ? "" : text)}
          >
            <IconButton className={`${className || ""}`} icon={icon} text={text} />
          </AccordionSummary>
          <AccordionDetails>
            <div>{children}</div>
          </AccordionDetails>
        </Accordion>
      ) : (
        <div className={`menuHiddenAccordion`}>
          <IconButton className={`menuIconSideBar  ${className || ""}`} icon={icon} hiddenArial={true} />
          <div className={`menuHiddenContent bg-primary`}>
            {" "}
            <div className={`menuHiddenTitle`}>{text}</div>
            {children}
          </div>
        </div>
      )}
    </div>
  );
}
